<template>
  <vue-js-modal
    v-if="logNode"
    :key="reload"
    id="agLogNodeModal"
    class="agModal"
    name="agLogNodeModal"
    draggable=".card-header"
    width="75%"
    height="85%"
    :shiftX=".5"
    :shiftY=".25"
    :resizable="true"
    :clickToClose="false">
    <b-card>
      <template #header>
        <h4 v-if="disableUI || isLoading" class="agModal-title">View Log Node {{logNode.shortname}}</h4>
        <h4 v-else class="agModal-title">Edit Log Node {{logNode.shortname}}</h4>
      </template>
      
      <div class="agInputGroup agInputGroupCentered">
          <label>Source(s):</label>
          <b-input type="text" :value="srcStr" autocomplete="false" disabled></b-input>
      </div>
      <b-input-group size="md" prepend="Name">
        <b-input type="text" v-model="logNode.name" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <b-input-group size="md" prepend="Description">
        <b-input type="text" v-model="logNode.description" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <hr>
      <div id="agLogNodeModal-multiSelect" class="agInputGroup agInputGroupCentered">
        <label>Inputs/Outputs:</label>
        <multiselect 
          v-model="objectSelections"
          :loading="isLoading"
          :options="objectOptions" 
          :multiple="true" 
          label="text"
          track-by="value"
          :close-on-select="false" 
          :clear-on-select="false" 
          :show-no-results="false" 
          placeholder="Click to select">
        </multiselect>
      </div>
      <hr>
      <div class="agInputGroup agInputGroupCentered">
        <input 
          type="checkbox" 
          v-model="logNode.enabled"
          :disabled="disableUI || isLoading"/>
        <label>Enabled</label>
      </div>
      <hr>
      <div class="agInputGroup agInputGroupCentered">
        <label>Destination:</label>
        <b-input type="text" :value="destName" class="agInput agExtraSmallInput" disabled></b-input>
      </div>

      <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>

        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click">
          Save
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click">
          Delete
        </b-button>
      </template>
    </b-card>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      id="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Log Node</h4>
      </template>
      Are you sure you want to delete log node
      <i>{{ name }}</i>?
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteButton_click">
          Delete
        </b-button>
      </template>
    </b-modal>

  </vue-js-modal>
</template>

<script>

// modules
import Vue from "vue";

// components

export default {
  name: "ag-logNode-modal",
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },
  data() {
    return {
      logNode: null,
      reload: 0,
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      objectOptions: [],
      objectSelections: [],
      selectedStr: "",
    };
  },
  computed: {

    name() {
      if(this.logNode.name)
        return this.logNode.name;
      
      return this.logNode.shortname;
    },

    srcStr() {
      if(!this.logNode.src || this.logNode.src.length == 0)
        return "";

      var srcStr = "";
      for(var i = 0; i < this.logNode.src.length; i++) {
        var src = this.logNode.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last , 
      return srcStr;
    },

    destName() {
      if(this.logNode.dest)
        return this.logNode.dest.shortname;
      return "";
    },
  },

  mounted() {},

  methods: {

    // UI Events

    cancelButton_click() {
      this.hide();
    },

    async saveButton_click() {
      this.modalMessage = "";

      let logObjects = this.objectSelections.map((opt) => opt.value);
      this.logNode.logObjects = logObjects;
      const node = {
        object: this.logNode,
        type: "logNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {node: node});
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "logNode",
          object: result.data.node
        };
        this.hide();
        this.hide();
        this.$emit("updatedNode", updated);
      } 
      else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.logNode,
        type: "logNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {node: node});
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();    
    },

    // other

    async show() {
      await this.setLogNode();
      await Vue.nextTick();
      await this.reset();
      this.$modal.show("agLogNodeModal");
    },

    hide() {
      this.$modal.hide("agLogNodeModal");
    },

    async reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      this.setObjectOptions();
    },

    async setLogNode() {
      if(this.node && this.node.type == "logNode") 
        this.logNode = this.workflow.logNodes.find((object) => object._id == this.node.object._id);
      else
        this.logNode = null;
    },

    setObjectOptions() {
      this.objectOptions = [];
      this.objectSelections = [];
    
      let nodeTypes = this.$store.getters["nodeStore/getInputAndOutputTypes"];
      for(let i = 0; i < nodeTypes.length; i++) {
        let nodeType = nodeTypes[i];
        if(!nodeType.plural)
          continue;

        let nodes = this.workflow[nodeType.plural];
        for(let j = 0; j < nodes.length; j++) {
          let node = nodes[j];
          let name = node.shortname;
          if(node.name)
            name += `: ${node.name}`;

          let option = {value: node.shortname, text: name};
          this.objectOptions.push(option);
          let isSaved = this.logNode.logObjects.find((shortname) => shortname == node.shortname);
          if(isSaved)
            this.objectSelections.push(option);
        }
      }
    },
  }
};

</script>

<style scoped lang="css">

#agLogNodeModal-multiSelect .multiselect{
  width: 750px;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/LogNodeModal.vue